import { createSelector } from 'reselect';

const loader = state => state.get('loader');

const getCurrentStatus = () => createSelector(loader, state => state.toJS().status);

export default getCurrentStatus;
